import React, { useState, useRef, useEffect } from "react";
import { FaCalendar } from "react-icons/fa6";
import { FaTimes } from "react-icons/fa";
import "./Modal.css";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import * as XLSX from "xlsx";
import { downloadProviderReport } from "../../../config/LiveApi";

const DownloadReportModal = ({ onClose }) => {
  const token = useSelector((store) => store.userReducer.token);
  const pickerRef = useRef();

  const [showPicker, setShowPicker] = useState(false);
  const [tempRange, setTempRange] = useState({
    startDate: new Date(new Date().setHours(0, 0, 0, 0)),
    endDate: new Date(new Date().setHours(23, 59, 59, 999)),
    key: "selection",
  });

  const [selectedRange, setSelectedRange] = useState(tempRange);
  const [isLoading, setIsLoading] = useState(false);

  const handleSelect = (ranges) => {
    setTempRange(ranges.selection);
  };

  const handleApply = () => {
    const diffTime = Math.abs(tempRange.endDate - tempRange.startDate);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays > 60) {
      toast.error("You can only select a maximum of 60 days.");
      return;
    }

    setSelectedRange(tempRange);
    setShowPicker(false);
  };

  const handleClickOutside = (e) => {
    if (pickerRef.current && !pickerRef.current.contains(e.target)) {
      setShowPicker(false);
    }
  };

  useEffect(() => {
    if (showPicker) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showPicker]);

  const handleDownload = async () => {
    const formattedStart = selectedRange.startDate.toISOString();
    const formattedEnd = selectedRange.endDate.toISOString();

    try {
      setIsLoading(true);
      const blobData = await downloadProviderReport(token, formattedStart, formattedEnd);
      const text = await blobData.text();
      const parsed = JSON.parse(text);

      if (!Array.isArray(parsed.data)) {
        toast.error("Invalid report format");
        return;
      }

      const worksheet = XLSX.utils.json_to_sheet(parsed.data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Rolling Reserve");

      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      const blob = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "provider_settlement.xlsx");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      toast.success("Report downloaded successfully");
      onClose();
    } catch (err) {
      toast.error("Failed to download report");
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div className="download-rr-modal-overlay">
        <div className="download-modal-content">
          <button onClick={onClose} className="download-modal-buttons-close">
            <FaTimes size={25} />
          </button>

          <h2 className="text-heading-download">Download Provider Settlement Report</h2>


          <div className="select-date-range-calendar">
            <div className="select-date-text">
              Selected Range:{" "}
              <span className="selected-date-text">
                {selectedRange.startDate.toLocaleDateString("en-GB")} -{" "}
                {selectedRange.endDate.toLocaleDateString("en-GB")}
              </span>
            </div>
          </div>

          <div className="calender-div">
            <div className="calendar-toggle-text">
              <p>Select Date:</p>
            </div>

            <div className="calendar-toggle-button">
              <button onClick={() => setShowPicker(!showPicker)}>
                <FaCalendar />
              </button>
            </div>
          </div>

          {showPicker && (
            <div className="calendar-picker-wrapper" ref={pickerRef}>
              <DateRangePicker
                ranges={[tempRange]}
                onChange={handleSelect}
                maxDate={new Date()}
                editableDateInputs={true}
              />
              <div>
                <button className="calendar-apply-button" onClick={handleApply}>
                  Apply
                </button>
              </div>
            </div>
          )}

          <div className="download-modal-buttons-recon">
            {isLoading ? (
              <button className="download-modal-buttons-process" disabled>
                Loading ...
              </button>
            ) : (
              <button onClick={handleDownload} className="download-modal-buttons-download">
                Download
              </button>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default DownloadReportModal;
